export default __webpack_public_path__ + "static/media/Paige_9781846162091.6e352444.jpg";